export const LOCAL_STORAGE_EMAIL_KEY = 'AUTH_X_LAST_USER'
export const LOCAL_STORAGE_LAST_LOGIN_EMAIL_KEY = 'AUTH_X_LAST_LOGIN_EMAIL'
export const LOCAL_STORAGE_REDIRECT_URI_KEY = 'AUTH_X_REDIRECT_URI'
export const LOCAL_STORAGE_TRUSTED_DEVICE_SETUP_REDIRECT_URI_KEY = 'AUTH_X_TRUSTED_DEVICE_SETUP_REDIRECT_URI'
export const LOCAL_STORAGE_TRUSTED_DEVICE_SETUP_ORIGIN_KEY = 'AUTH_X_TRUSTED_DEVICE_SETUP_ORIGIN'
export const LOCAL_STORAGE_MFA_SETUP_REDIRECT_URI_KEY = 'AUTH_X_MFA_SETUP_REDIRECT_URI'
export const LOCAL_STORAGE_MOBILE_REDIRECT_URI_KEY = 'AUTH_X_MOBILE_REDIRECT_URI'
export const LOCAL_STORAGE_THEME_CODE_KEY = 'AUTH_X_THEME_CODE'
export const LOCAL_STORAGE_REDIRECT_URI_PASSKEY_KEY = 'LOCAL_STORAGE_REDIRECT_URI_PASSKEY_KEY'
// passkey step-up: the passkey the step-up authorises an action on (e.g. delete), kept across the
// Auth0 round trip and sent to createPasskeyState so the state is bound to that passkey
export const LOCAL_STORAGE_PASSKEY_STEP_UP_PASSKEY_ID_KEY = 'AUTH_X_PASSKEY_STEP_UP_PASSKEY_ID'
export const LOCAL_STORAGE_IID_KEY = 'AUTH_X_IID'
export const COOKIES_DEVICE_ID = 'AUTH_X_DEVICE_ID'
export const COOKIES_TOKEN_KEY = 'AUTH_X_TOKEN'

export const SESSION_ID = 'AUTH_X_SESSION_ID'
// sessionStorage: force_mfa=true with prompt=login (mobile app, opened without iid) — TOTP-only MFA
// setup and no trusted device enrolment for this login only. Dies with the tab.
export const SESSION_FORCE_MFA_TOTP_ONLY_KEY = 'AUTH_X_FORCE_MFA_TOTP_ONLY'
export const SESSION_TIME = 'AUTH_X_SESSION_TIME'
export const PASSKEY_REGISTRATION_TIME = 'AUTH_X_PASSKEY_REGISTRATION_TIME'
export const SESSION_STEP = 'AUTH_X_STEP'
export const INCOMPLETE_SESSION_STEP = 'AUTH_X_INCOMPLETE_STEP'
export const SESSION_PASSKEY_REGISTRATION_STEP = 'AUTH_X_PASSKEY_REGISTRATION_STEP'

export const PASSWORD_EXPRESSION = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{12,2048}$/
// Password must be at least 12 characters, no more than 2048 characters, and
// It must contain an uppercase letter, a lowercase letter, a number and be at least 12 characters long

export const IMPOSSIBLE_TRAVEL_ERROR_MESSAGE = 'access denied due to risk assessment scores'

// /login/passkey: Universal Login's back-to-login link for a cancelled passkey login. Auth0 rejects
// any ext-* param not matching /^[-\w.*~@+ /:]{1,255}$/, so the cancel marker is a path segment —
// no query string (no ?, =, & or %) and no redirectUri; the page uses the redirectUri it stored
export const PASSKEY_LOGIN_CANCELLED_PATH = '/login/passkey/cancelled'
// /login/passkey: outcome appended to the app's redirectUri when the user cancels the passkey login
export const PASSKEY_LOGIN_OUTCOME_QUERY = 'passkeyLogin'
export const PASSKEY_LOGIN_CANCELLED_OUTCOME = 'cancelled'
